export const enum whatifProcess {
    editPaymentIn = "Edit payments in",
    editAdviserCharges = "Edit adviser charges",
    AddAdditionalAdviserCharge = "Add additional adviser charge",
    editInvestmentSeletion = "Edit investment selection",
    AddEditRegularWithdrawals = "Add/edit regular withdrawals",
    AddOneOffWithdrawal = "Add one-off withdrawal",
}

export const whatIfModelArray = [
    whatifProcess.editPaymentIn,
    whatifProcess.editAdviserCharges,
    whatifProcess.AddAdditionalAdviserCharge,
    whatifProcess.editInvestmentSeletion,
    whatifProcess.AddEditRegularWithdrawals,
    whatifProcess.AddOneOffWithdrawal,
];

export const stepTitle = {
    ClientDetails: "Client details",
    ChangesToBeModelled: "Changes to be modelled",
    EditPaymentIn: "Edit payments in",
    EditAdviserCharges: "Edit adviser charges",
    editInvestmentSeletion: "Edit investment selection",
    AddAdditionAdviserCharges: "Add additional adviser charge",
    addEditRegularWithdrawals: "Add/edit regular withdrawals",
    addOneOffWithdrawal: "Add one-off withdrawal",
    review: "Illustration ready",
    confirm: "Confirmation",
};
